import { render, staticRenderFns } from "./ServiceListTable.vue?vue&type=template&id=08ded058&scoped=true"
import script from "./ServiceListTable.vue?vue&type=script&lang=js"
export * from "./ServiceListTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceListTable.vue?vue&type=style&index=0&id=08ded058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ded058",
  null
  
)

export default component.exports